import { CONTACT_EMAIL, EMAIL_COMPOSE_URL, FOUNDER_NAME, LINKEDIN_URL } from "../data/site";

export const Footer = () => (
  <footer
    className="min-h-16 flex flex-col md:flex-row gap-3 md:gap-0 items-center px-5 md:px-10 py-5 md:py-0 md:h-16 border-t border-deep text-[10px] font-medium uppercase tracking-[0.2em] justify-between text-center text-paper bg-deep"
    data-testid="footer"
  >
    <div>© 2026 Enchanté · Art Fair Travel Advisory</div>
    <div className="text-paper/80 flex flex-col md:flex-row items-center gap-1 md:gap-3">
      <span>Travel booked through Fora · Virtuoso</span>
      <span className="hidden md:inline" aria-hidden="true">·</span>
      <a
        href={LINKEDIN_URL}
        target="_blank"
        rel="noopener"
        className="text-paper border-b border-paper/40 hover:border-paper transition-colors py-1 inline-flex items-center"
        data-testid="footer-founder-link"
      >
        Founded by {FOUNDER_NAME}
      </a>
    </div>
    <div className="flex items-center gap-2">
      <span className="w-2 h-2 rounded-full bg-accent"></span>
      Manama · GMT+3 ·
      <a
        href={EMAIL_COMPOSE_URL}
        target="_blank"
        rel="noopener"
        className="normal-case tracking-normal font-medium text-[12px] py-2 inline-flex items-center"
        data-testid="footer-email-link"
      >
        {CONTACT_EMAIL}
      </a>
    </div>
  </footer>
);
